module.exports = __webpack_public_path__ + "static/lato-latin-100.9f2d9639.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-100.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-100.woff
// module chunks = 17241999800008180000